import React, { useEffect, useState } from 'react'
import { Checkbox, makeStyles , FormControlLabel, Grid, IconButton, Paper, TableBody, TableCell, TableRow, Tooltip, Typography } from '@material-ui/core';
import { Table } from 'reactstrap';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from "@material-ui/icons/Save";
import BlockIcon from "@material-ui/icons/Block";

const useStyles = makeStyles({
  smallLabel: {
    '& .MuiFormControlLabel-label': {
      fontSize: '15px',
    },
  },
});

export default function FormDisability({listDisabilities, selectedDisability, handleSelectDisability, edit_disability, handleEditDisability, updateDisability, id_admision}) {
  const [discapacidadesSeleccionadas, setDiscapacidadesSeleccionadas] = useState({});
  const classes = useStyles();


  useEffect(()=>{
    const disabilities = {}
    listDisabilities.forEach((discapacidad) => {      
      disabilities[discapacidad.id_discapacidad] = {checked: !!selectedDisability.find((dis) => dis.id_discapacidad === discapacidad.id_discapacidad) };
      discapacidad.tipo.tipo.forEach((tipo)=>{
        disabilities[discapacidad.id_discapacidad][tipo.id] = !!selectedDisability.find((dis) => dis.id_discapacidad === discapacidad.id_discapacidad && dis.tipo.some((t) => t.id === tipo.id));
      })
    });
    setDiscapacidadesSeleccionadas(disabilities);
  },[])

  useEffect(() => {    
    if (id_admision === "" || id_admision === undefined || id_admision === null) {
      handleEditDisability(true)
    }
  },[id_admision]);

  
  const handleToggleGrupo = (id_discapacidad, nombre) => {
    const isChecked = selectedDisability.find((dis) => dis.id_discapacidad === id_discapacidad)
    if(isChecked) {
      handleSelectDisability(selectedDisability.filter((dis)=> dis.id_discapacidad !== id_discapacidad))
      setDiscapacidadesSeleccionadas({...discapacidadesSeleccionadas,[id_discapacidad]:{ ...discapacidadesSeleccionadas[id_discapacidad], checked: false}})
    }else{
      handleSelectDisability([...selectedDisability, {
        id_discapacidad,
        nombre,
        tipo: []
      }])
      setDiscapacidadesSeleccionadas({...discapacidadesSeleccionadas,[id_discapacidad]:{ ...discapacidadesSeleccionadas[id_discapacidad], checked: true}})
    }
    
  };

  const handleToggleTipo = (id_discapacidad, id_tipo,nombre_tipo) => {

    const disabilityFound = selectedDisability.find((dis) => dis.id_discapacidad === id_discapacidad)
    
    const isChecked = disabilityFound.tipo.find((tipo) => tipo.id === id_tipo)
    
    if(isChecked) {
      const updatedDisability = {
        ...disabilityFound,
        tipo: disabilityFound.tipo.filter((tipo) => tipo.id !==id_tipo)
      }
      handleSelectDisability(selectedDisability.map((dis) => dis.id_discapacidad === id_discapacidad ? updatedDisability : dis))
      setDiscapacidadesSeleccionadas({
        ...discapacidadesSeleccionadas,
        [id_discapacidad]: {
          ...discapacidadesSeleccionadas[id_discapacidad],
          [id_tipo]: false,
          checked: true
        }
      });
    }else{
      const updatedDisability = {
        ...disabilityFound,
        tipo: [...disabilityFound.tipo, { id: id_tipo, nombre: nombre_tipo}]
      };
      
      handleSelectDisability(selectedDisability.map((dis) => dis.id_discapacidad === id_discapacidad ? updatedDisability : dis));
      setDiscapacidadesSeleccionadas({
        ...discapacidadesSeleccionadas,
        [id_discapacidad]: {
          ...discapacidadesSeleccionadas[id_discapacidad],
          [id_tipo]: true,
          checked: true
        }
      });
    }

  };

    return (
        <Paper style={{ padding: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#cce5ff', padding: 8 }}>
           <div style={{ marginLeft: 10, marginTop: 10 }}>
              <h4>Discapacidad</h4>
            </div>
              
            {id_admision === "" || id_admision === undefined || id_admision === null ? null
            : (
              edit_disability === false ? (
                    <Tooltip title="Editar Discapacidad">
                      <IconButton
                          aria-label="Editar discapacidad"
                          onClick={() => handleEditDisability(true)}
                          component="span"                      >
                          <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                ):(
                  <div style={{display: 'flex', alignItems: 'left'}}>
                    <Tooltip title="Actualizar Discapacidad">
                      <IconButton
                        aria-label="upload picture"
                        component="span"
                        onClick={() => {
                          updateDisability();
                        }}
                      >
                        <SaveIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Cancelar Edición">
                      <IconButton
                        aria-label="upload picture"
                        component="span"
                        onClick={() => handleEditDisability(false)}
                      >
                        <BlockIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                )
            )
                
            }
        </div>
       <Table>
          <TableBody>
          {listDisabilities.map((grupo) => {          
            return (
              <TableRow key={grupo.id_discapacidad}>
                <TableCell style={{ width: '40%', borderBottom: '1px solid #ccc' }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!!discapacidadesSeleccionadas[grupo.id_discapacidad]?.checked}
                        onChange={() => handleToggleGrupo(grupo.id_discapacidad, grupo.nombre)}
                      />
                    }
                    disabled={!edit_disability}
                    label={grupo.nombre}
                    className={classes.smallLabel}
                  />
                </TableCell>
                <TableCell style={{ borderBottom: '1px solid #ccc' }}>
                  <Grid container spacing={1}>
                    {grupo.tipo.tipo.map((sub) => {                      
                      return (
                        <Grid item xs={12} sm={6} key={sub.id}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={!!discapacidadesSeleccionadas[grupo.id_discapacidad]?.[sub.id] }
                                onChange={() => handleToggleTipo(grupo.id_discapacidad, sub.id, sub.nombre)} 
                              />
                            }
                            disabled={!discapacidadesSeleccionadas[grupo.id_discapacidad]?.checked || !edit_disability}
                            label={sub.nombre}
                            className={classes.smallLabel}
                          />
                        </Grid>
                      )
                    })}
                  </Grid>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Paper>

  )
}
